import React from 'react';

const WormEffect = () => (
  <div
    style={{
      position: 'absolute',
      inset: 0,
      pointerEvents: 'none',
      overflow: 'hidden',
    }}
  >
    <div
      style={{
        position: 'absolute',
        top: '45%',
        left: '-10%',
        width: '260px',
        height: '60px',
        background: 'linear-gradient(90deg, rgba(0,180,120,0.12), rgba(0,180,120,0.06), rgba(0,180,120,0))',
        filter: 'blur(10px)',
        transform: 'rotate(-45deg)',
        animation: 'egg-walk 18s linear forwards',
        opacity: 0.7,
      }}
      className="egg-slime"
      aria-hidden="true"
    />
    <div
      style={{
        position: 'absolute',
        top: '45%',
        left: '-1%',
        fontSize: '92px',
        animation: 'egg-walk 18s linear forwards',
        transform: 'rotate(45deg)',
      }}
      aria-hidden="true"
    >
      🪱
    </div>
  </div>
);

export default WormEffect;

